import React, { StrictMode } from 'react';

import { FeatureSwitch } from '../configuration';
import { AppRoutes } from '../routes';
import { SessionManager } from '../session/components/session-manager';
import {
    ModalManager, MODAL_VARIANT_COMPONENTS, AppServices
} from './components';
import CheckMailVerificationStatus
    from './components/check-email-verification/check-mail-verification-status/check-mail-verification-status';
import { ProductLicenceManager } from './components/product-licence/product-licence-manager';

const AppMain = () => {
    return (
        <StrictMode>
            <ProductLicenceManager />
            <ModalManager variants={MODAL_VARIANT_COMPONENTS} />
            <SessionManager />
            <AppServices />
            <AppRoutes />
            <FeatureSwitch configKey={'FeatureEmailVerificationModal'}>
                <CheckMailVerificationStatus />
            </FeatureSwitch>
        </StrictMode>
    );
};

export { AppMain as default };
